module.exports = __webpack_public_path__ + "img/about_6.d197bd1b.png";